import PageLoader from "components/general/PageLoader";
import { Box, Button, H1, H3, Text, View } from "components/ui";
import { useLocalSearchParams } from "expo-router";
import { Formik } from "formik";
import React, { useState } from "react";
import { ActivityIndicator } from "react-native";
import { useGetUserByIdQuery, usePutUserByIdMutation } from "store/abcoApi";
import * as Yup from "yup";
import FormField from "components/form/FormField";
import UserForm from "components/form/UserForm";

export default function Page() {
	const { id } = useLocalSearchParams<{ id: string }>();


	const {
		data: user,
		isLoading,
		isFetching,
		isError,
	} = useGetUserByIdQuery({
		id: Number(id),
	});

	const validationSchema = Yup.object().shape({
		firstName: Yup.string().required("First name is required").min(2, "First name must be at least 2 characters"),
		lastName: Yup.string().required("Last name is required").min(2, "Last name must be at least 2 characters"),
		email: Yup.string().required("Email is required").email("Invalid email format"),
	});

	if (user == null && isFetching) {
		return (
			<Box minHeight={500}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<Box gap={20}>
			<Box>
				<H3>User Details</H3>
			</Box>

			<UserForm user={user} isNew={false} />
		</Box>
	);
}
